import Footer from "layout/Footer/Footer";

export default Footer;
